import { createLogic } from 'redux-logic';
import { stateGo } from 'redux-ui-router';
import { hosts, facebook } from 'settings';
import { fetchMember } from './member';
import { memberStorage } from 'utils';

// Actions
const LOGIN = '@@app/auth/LOGIN';
const LOGIN_SUCCESS = '@@app/auth/LOGIN_SUCCESS';
const LOGIN_ERROR = '@@app/auth/LOGIN_ERROR';

const LOGIN_FACEBOOK = '@@app/auth/LOGIN_FACEBOOK';
const LOGIN_FACEBOOK_SUCCESS = '@@app/auth/LOGIN_FACEBOOK_SUCCESS';
const LOGIN_FACEBOOK_ERROR = '@@app/auth/LOGIN_FACEBOOK_ERROR';

const LOGOUT = '@@app/auth/LOGOUT';
const LOGOUT_SUCCESS = '@@app/auth/LOGOUT_SUCCESS';

const CANCEL = '@@app/auth/CANCEL';

// Initial State
export const initialState = {
  error: false,
  isLoading: false,
  message: '',
  facebookAccessToken: null,
};

// Observables
const facebookLogic = createLogic({
  type: LOGIN_FACEBOOK,
  cancelType: CANCEL,
  process({ httpClient }, dispatch, done) {
    const onSuccess = authResponse => {
      const endpoint = '/v1/login-with-facebook';
      const params = {
        token: authResponse.accessToken,
        rememberMe: true,
        callbackUrl: window.location.href,
      };

      httpClient
        .post(endpoint, params)
        .then(response =>
          dispatch({ type: LOGIN_SUCCESS, payload: response.data })
        )
        .catch(() =>
          dispatch({ type: LOGIN_FACEBOOK_SUCCESS, payload: authResponse })
        )
        .then(done);
    };

    const onFail = message => {
      dispatch({ type: LOGIN_FACEBOOK_ERROR, payload: { message } });
      done();
    };

    try {
      window.FB.getLoginStatus(response => {
        response.status === 'connected'
          ? onSuccess(response.authResponse)
          : onFail('Failed to login to Facebook.');
      });
    } catch (e) {
      onFail('Failed to access Facebook.');
    }
  },
});

const loginLogic = createLogic({
  type: LOGIN,
  cancelType: CANCEL,
  processOptions: {
    successType: LOGIN_SUCCESS,
    failType: LOGIN_ERROR,
  },
  process({ action, httpClient }) {
    // TODO: Implement when we get the new endpoint
    // const endpoint = action.payload.facebookAccessToken
    //   ? '/v1/login/new-facebook-endpoint'
    //   : '/v1/login';

    // return (
    //   httpClient
    //     .post(endpoint, action.payload)
    //     .then(response => response.data);
    // );

    const { email, password, rememberMe, facebookAccessToken } = action.payload;
    const params = { email, password, rememberMe };

    return httpClient.post('/v1/login', params).then(response => {
      if (facebookAccessToken) {
        httpClient.post('/v2/facebook-profile', {
          callbackUrl: window.location.href,
          token: facebookAccessToken,
        });
      }
      if (response.data) {
        window.localStorage.setItem('token', response.data.authToken);
      }

      return response.data;
    });
  },
});

const logoutLogic = createLogic({
  type: LOGOUT,
  cancelType: CANCEL,
  processOptions: {
    successType: LOGOUT_SUCCESS,
    failType: LOGOUT_SUCCESS,
  },
  process({ httpClient }) {
    return httpClient.get('/v1/logout');
  },
});

const onSuccessLogic = createLogic({
  type: [LOGIN_SUCCESS, LOGOUT_SUCCESS],
  process({ action, memberStorage }, dispatch, done) {
    const { payload, type } = action;

    switch (type) {
      case LOGIN_SUCCESS: {
        // authCheck will redirect member to correct page.
        dispatch(fetchMember(payload.memberId));
        break;
      }

      case LOGOUT_SUCCESS: {
        const { redirectTo } = memberStorage.get();

        if (redirectTo && redirectTo.name === 'welcome') {
          dispatch(stateGo('login'));
        } else {
          memberStorage.remove();
          setTimeout(() => window.location.assign('/'));
        }

        break;
      }
    }

    done();
  },
});

export const authLogic = [
  facebookLogic,
  loginLogic,
  logoutLogic,
  onSuccessLogic,
];

// Action Creators
export const authLogin = (params, facebookAccessToken) => {
  const { email, password, rememberMe } = params;
  return {
    type: LOGIN,
    payload: { email, password, rememberMe, facebookAccessToken },
  };
};

export const authLogout = message => {
  return { type: LOGOUT, payload: { message } };
};

export const authLoginFacebook = () => {
  return { type: LOGIN_FACEBOOK };
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case LOGIN:
    case LOGIN_FACEBOOK:
      return {
        ...state,
        error: false,
        isLoading: true,
        message: '',
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        error: false,
        isLoading: false,
        message: '',
      };

    case LOGIN_FACEBOOK_SUCCESS:
      return {
        ...state,
        error: false,
        isLoading: false,
        message: '',
        facebookAccessToken: payload.accessToken,
      };

    case LOGIN_ERROR:
      return {
        ...state,
        error: true,
        isLoading: false,
        message: 'Incorrect email or password.',
      };

    case LOGIN_FACEBOOK_ERROR:
      return {
        ...state,
        error: true,
        isLoading: false,
        message: payload.message,
      };

    case LOGOUT:
      return {
        ...state,
        isLoading: true,
        message: payload.message,
      };

    case LOGOUT_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/logic/auth.js